import React, { useEffect } from 'react'
import { Dispatch } from 'redux'
import { IGroup } from '../../types/group'
import { ISearch } from '../../types/search'
import { ICapabilitiesSummary } from '../../types/capabilitiesSummary'
import { IGroupParam } from '../../types/router'
import { getGroups } from '../../actions/groups'
import { getCapabilitiesSummary } from '../../actions/capabilitiesSummary'
import { getDataStreamAllowedDomainsAction } from '../../actions/config'
import { useSearch } from '../../hooks'
import { colors, BlueThemeProvider } from '../../styles'
import { Main } from '../../layouts'
import {
  CombinedTitle,
  PackList,
  ControlledInfiniteScroll,
  Breadcrumbs,
} from '../../components'
import { GroupPublishPageSidebar } from './GroupPublishPageSidebar'
import { RouteComponentProps } from 'react-router'

export interface IGroupPublishPageConnectedProps {
  group?: IGroup
  groupsLoading: boolean
  groupsLoaded: boolean
  search: ISearch
  capabilitiesSummary?: ICapabilitiesSummary
  dispatch: Dispatch
}

export const GroupPublishPage = ({
  match: {
    params: { groupId },
  },
  location,
  group,
  groupsLoading,
  groupsLoaded,
  search,
  capabilitiesSummary,
  dispatch,
}: IGroupPublishPageConnectedProps & RouteComponentProps<IGroupParam>) => {
  const [takeNextChunk] = useSearch({
    isConsumer: false,
    search,
    location,
    groupId,
    dispatch,
  })

  useEffect(() => {
    if (!groupsLoaded && !groupsLoading) {
      dispatch(getGroups())
    }
  })

  useEffect(() => {
    dispatch(getCapabilitiesSummary(groupId))
  }, [dispatch, groupId])

  useEffect(() => {
    dispatch(getDataStreamAllowedDomainsAction())
  }, [dispatch])

  return group ? (
    <BlueThemeProvider>
      <Main
        header={group && <Breadcrumbs group={group} />}
        sidebarSecondary={
          <GroupPublishPageSidebar
            groupId={groupId}
            capabilitiesSummary={capabilitiesSummary}
          />
        }
        titleBlock={
          <CombinedTitle
            first={group.shortTitle}
            second="Group"
            color={colors.blue}
          />
        }
        helmet={group && `Reuters Graphics: ${group.shortTitle}`}
      >
        <ControlledInfiniteScroll
          component={PackList}
          takeNextChunk={takeNextChunk}
          search={search}
        />
      </Main>
    </BlueThemeProvider>
  ) : null
}
